import { render, staticRenderFns } from "./ModificaStruttura.vue?vue&type=template&id=fd643326&scoped=true&"
import script from "./ModificaStruttura.vue?vue&type=script&lang=js&"
export * from "./ModificaStruttura.vue?vue&type=script&lang=js&"
import style0 from "./ModificaStruttura.vue?vue&type=style&index=0&id=fd643326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd643326",
  null
  
)

export default component.exports